import { v3 } from "backoffice-api"
import { orderedItems } from "./orderedItems"
import type { SharedItem } from "./types"

type SharedItems = {
  /** In the order of the requested ids; ids the caller cannot open are left out. */
  items: SharedItem[] | undefined
  isError: boolean
}

/**
 * Resolve product ids to displayable card metadata in one batched `filter[ids]`
 * lookup on `GET /api/v3/shared_items` (BACKINT-642), which works in every
 * company. Per-caller authorized: an id the caller cannot open is absent from
 * `items`.
 *
 * `items` is `undefined` while the lookup is in flight. Not cached forever:
 * access and title can change, so this refetches on the default policy.
 */
export function useSharedItems(ids: string[]): SharedItems {
  const idsParam = ids.join(",")

  const { data, isError } = v3.getSharedItems.useQuery(
    [{ "filter[ids]": idsParam }],
    { enabled: ids.length > 0 }
  )

  const items = data && orderedItems(ids, data.data)

  return { items, isError }
}
